<template>
    <div class="client-selection">
        <div class="client-selection-search">
            <div class="client-selection-search__description">
                {{trans('users.searchbar')}}
            </div>
            <div class="client-selection-search__searchbar">
                <search-bar
                    :placeholder="'vuetables.search.placeholder.client'">
                </search-bar>
            </div>
        </div>

        <v-server-table :url="route('tenantapi.clients.index-selection')" :columns="columns" :options="tableOptions" ref="table">
            <label class="radio-button" slot="radio" slot-scope="props">
                <input type="radio" name="client" :checked="selectedClient.id == props.row.id">
                <span class="radio-button__checkmark"></span>
            </label>

            <colored-letter-square slot="cls_column"
                slot-scope="props"
                :name="props.row.name"
                :length="2"
            >
            </colored-letter-square>

            <div slot="name" slot-scope="props" :id="props.row.id">
                <div class="VueTables__primary-content">{{ props.row.name }}</div>
                <div class="VueTables__secondary-content">{{ props.row.prefixed_name }}</div>
            </div>
        </v-server-table>
    </div>
</template>

<script>
import { EventBus } from '../eventbus.js';
import { Event } from 'vue-tables-2';

export default {
    props: {
        preselectedClient: Object,
    },

    data() {
        return {
            selected: null,

            columns: ['radio','cls_column','name', 'city'],

            tableOptions: {
                headings: {
                    radio:'',
                    checkbox: '',
                    cls_column:'',
                    name: this.trans('clients.label.name'),
                    city: this.trans('clients.label.city'),
                },

                orderBy: {
                    column: 'name',
                    ascending: true
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.noResults'),
                    loading: Vue.prototype.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search')
                },

                sortable: ['prefixed_name', 'city'],
            },
            selectedClient: this.preselectedClient || {},
        };
    },

    created() {
        // Event.$on('vue-tables.row-click', e => this.setId(e));

        /**
        * Ajax-Call to get data asJSON to fill the table.
        */
        axios
            .get(this.apiGetUrl)
            .then(response => {
                if (response.data instanceof Array) {
                    this.tableData = response.data;
                } else {
                    this.tableData = response.data.data;
                }

                /**
                * when the site is loading it will show the message "loading files" and after loading it will
                * replaced with "no entries found" message because while loading files the table shows the
                * message "no entries found".
                */
                this.options.texts.noResults = this.trans('vuetables.label.noResults');
        });
        Event.$on('vue-tables.row-click', (e) => {
            this.selectedClient = e.row;
            Event.$emit('change-client-selection', this.selectedClient);
        });

        var filter = this.debounce((query) => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });
    },
};
</script>

